import { render, staticRenderFns } from "./DocsSubNav.vue?vue&type=template&id=7d8d2a39&scoped=true"
import script from "./DocsSubNav.vue?vue&type=script&lang=js"
export * from "./DocsSubNav.vue?vue&type=script&lang=js"
import style0 from "./DocsSubNav.vue?vue&type=style&index=0&id=7d8d2a39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8d2a39",
  null
  
)

export default component.exports